/* Bundle builder mix & match — Offre Shorts progressive.
   Anime [data-rm-builder] : slots (modèle/coloris/taille), total before/after
   (1 short -15%, 2 shorts -25%, 3+ shorts -35% par unité), ajout du pack
   en un appel via le pipeline du thème (cart_add_url + sections + dispatch
   shapes:cart:afteradditem → le drawer s'ouvre/se met à jour tout seul). */
(function () {
  'use strict';

  if (window.__rmBuilderInit) return;
  window.__rmBuilderInit = true;

  var CART_SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';

  /* Utilise le format monétaire du marché courant injecté par js-bridge.liquid. */
  function money(cents) {
    if (typeof formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return formatMoney(Number(cents) || 0, window.theme.moneyFormat);
    }
    return String(Number(cents) || 0);
  }

  /* Prix barré (compare-at) → prix courant. */
  function beforeAfter(compare, price) {
    if (compare > price) return '<s>' + money(compare) + '</s> ' + money(price);
    return money(price);
  }

  /* Offre progressive : remise appliquée à CHAQUE short, croissante avec la quantité.
     Doit rester alignée sur la Function backend (1 = 15 %, 2 = 25 %, 3+ = 35 %). */
  function paidPercent(quantity) {
    if (quantity >= 3) return 65;
    if (quantity === 2) return 75;
    return 85;
  }

  function tierDiscountPercent(quantity) {
    return 100 - paidPercent(quantity);
  }

  function offerPrice(compareAtCents, quantity) {
    return Math.round((Number(compareAtCents) || 0) * paidPercent(quantity) / 100);
  }

  function cartRoute(path) {
    var rootRoute = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return rootRoute.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function initBuilder(root) {
    var dataEl = root.querySelector('[data-rm-builder-data]');
    if (!dataEl || root.hasAttribute('data-rm-builder-ready')) return;
    root.setAttribute('data-rm-builder-ready', '');

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (err) {
      root.hidden = true;
      return;
    }

    var products = data.products || [];
    var labels = data.labels || {};
    var eligibleProductIds = {};
    if (!products.length) {
      root.hidden = true;
      return;
    }

    var byId = {};
    products.forEach(function (p) {
      /* Normalise les espaces insécables des titres Shopify. */
      p.model = (p.model || '').replace(/\u00a0/g, ' ').trim();
      p.color = (p.color || '').replace(/\u00a0/g, ' ').trim();
      p.variants = p.variants || [];
      p.variants.forEach(function (v) {
        v.price = Number(v.price) || Number(p.price) || 0;
        v.compare = Number(v.compare) || 0;
      });
      byId[p.id] = p;
      eligibleProductIds[String(p.id)] = true;
    });

    var current = byId[data.currentId];
    if (!current) {
      root.hidden = true;
      return;
    }

    var productFormId = root.getAttribute('data-product-form-id');
    var builderNamespace = productFormId || String(data.currentId);
    var section = root.closest('.shopify-section') || document;

    function productForm() {
      if (productFormId) return document.getElementById(productFormId);
      return section.querySelector('form[data-product-form]');
    }

    function formMatchesBuilder(form) {
      if (!form || !form.hasAttribute('data-product-form')) return false;
      if (productFormId) return form.getAttribute('id') === productFormId;
      return section.contains(form);
    }

    function quantityInput(form) {
      if (!form) return null;
      var formId = form.getAttribute('id');
      return (formId && document.querySelector('input[name="quantity"][form="' + formId + '"]'))
        || form.querySelector('input[name="quantity"]');
    }

    function setQuantityVisible(visible) {
      var form = productForm();
      var input = quantityInput(form);
      if (!input) return;

      var quantityRoot = input.closest('data-island') || input.closest('.product-block') || input.parentNode;
      if (quantityRoot) quantityRoot.style.display = visible ? '' : 'none';
      if (!visible && input.value !== '1') {
        input.value = '1';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /* Le sélecteur de taille natif du thème est remplacé par les pills du builder.
       Il reste dans le DOM pour le fallback noscript et la validité du formulaire. */
    section.querySelectorAll('.product-variant-picker-block').forEach(function (el) {
      el.style.display = 'none';
    });

    /* Groupes de modèles (Bannout / Dream Short… — coupes différentes). */
    var models = [];
    products.forEach(function (p) {
      if (models.indexOf(p.model) === -1) models.push(p.model);
    });

    function variantById(p, id) {
      if (!p) return null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].id === id) return p.variants[i];
      }
      return null;
    }

    function firstAvailableVariant(p) {
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available) return p.variants[i].id;
      }
      return p.variants.length ? p.variants[0].id : null;
    }

    function variantTitle(p, id) {
      var variant = variantById(p, id);
      return variant ? variant.title : '';
    }

    function variantWithTitle(p, title) {
      if (!p || !title) return null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available && p.variants[i].title === title) return p.variants[i];
      }
      return null;
    }

    function preferredVariant(p, preferredTitle) {
      var sameSize = variantWithTitle(p, preferredTitle);
      if (sameSize) return sameSize.id;
      return firstAvailableVariant(p);
    }

    /* Slot 1 = le short de la page courante, avec la taille déjà choisie
       dans le formulaire produit (select/input name="id" du thème). */
    function pdpSelectedVariant() {
      var form = productForm();
      var el = form
        ? form.querySelector('select[name="id"], input[name="id"]:checked, input[type="hidden"][name="id"]')
        : null;
      if (!el) return null;
      var id = parseInt(el.value, 10);
      var match = current.variants.some(function (v) { return v.id === id && v.available; });
      return match ? id : null;
    }

    var initialVariant = pdpSelectedVariant() || firstAvailableVariant(current);
    var initialSize = variantTitle(current, initialVariant);

    /* Slots 2 et 3 : par défaut, d'AUTRES coloris du même modèle que le short
       de la page, avec la même taille quand elle existe. */
    var sameModelOthers = products.filter(function (p) {
      return p.model === current.model && p.id !== current.id;
    });
    var defaultSlot2 = sameModelOthers[0] || current;
    var defaultSlot3 = sameModelOthers[1] || sameModelOthers[0] || current;

    var state = {
      tier: 3,
      cartShortCount: 0,
      cartPricingReady: false,
      cartPricingFailed: false,
      cartRequestId: 0,
      slots: [
        { productId: current.id, variantId: initialVariant, sizeTouched: false },
        { productId: defaultSlot2.id, variantId: preferredVariant(defaultSlot2, initialSize), sizeTouched: false },
        { productId: defaultSlot3.id, variantId: preferredVariant(defaultSlot3, initialSize), sizeTouched: false }
      ]
    };

    var slotEls = root.querySelectorAll('[data-slot]');
    var tier1SizesEl = root.querySelector('[data-tier1-sizes]');

    function slotProduct(slot) {
      return byId[slot.productId];
    }

    function slotVariant(slot) {
      var p = slotProduct(slot);
      return variantById(p, slot.variantId) || variantById(p, firstAvailableVariant(p));
    }

    function slotPrice(slot) {
      var p = slotProduct(slot);
      var v = slotVariant(slot);
      return v ? v.price : Number(p.price) || 0;
    }

    function slotCompare(slot) {
      var p = slotProduct(slot);
      var v = slotVariant(slot);
      var price = v ? v.price : Number(p.price) || 0;
      var compare = v && v.compare > 0 ? v.compare : Number(p.compare) || 0;
      return compare > price ? compare : price;
    }

    function tierSlots(count) {
      if (count === 1) {
        var selectedSlot = state.slots[0];
        var selectedProduct = slotProduct(selectedSlot);
        var selectedTitle = variantTitle(selectedProduct, selectedSlot.variantId);
        return [{
          productId: current.id,
          variantId: preferredVariant(current, selectedTitle) || firstAvailableVariant(current),
          sizeTouched: false
        }];
      }
      return state.slots.slice(0, count);
    }

    function visibleSlots() {
      return tierSlots(state.tier);
    }

    var renderSlot;
    var renderTotals;

    function totalsForSlots(slots) {
      var currentBefore = slots.map(slotPrice).reduce(function (a, b) { return a + b; }, 0);
      var regularBefore = slots.map(slotCompare).reduce(function (a, b) { return a + b; }, 0);
      var totalShortCount = state.cartPricingReady ? state.cartShortCount + slots.length : slots.length;
      var after = slots.map(function (slot) {
        return offerPrice(slotCompare(slot), totalShortCount);
      }).reduce(function (a, b) { return a + b; }, 0);
      var offerDiscount = Math.max(currentBefore - after, 0);
      return {
        currentBefore: currentBefore,
        regularBefore: regularBefore,
        offerDiscount: offerDiscount,
        totalSaving: regularBefore - after,
        after: after
      };
    }

    function totals() {
      return totalsForSlots(visibleSlots());
    }

    function refreshCartPricing() {
      var requestId = state.cartRequestId + 1;
      state.cartRequestId = requestId;
      root.setAttribute('aria-busy', 'true');

      return fetch(cartRoute('cart.js'), {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Unable to read cart');
          return res.json();
        })
        .then(function (cart) {
          if (requestId !== state.cartRequestId) return;
          var count = 0;
          (cart.items || []).forEach(function (item) {
            if (!eligibleProductIds[String(item.product_id)]) return;
            count += Number(item.quantity) || 0;
          });
          state.cartShortCount = count;
          state.cartPricingReady = true;
          state.cartPricingFailed = false;
        })
        .catch(function () {
          if (requestId !== state.cartRequestId) return;
          state.cartShortCount = 0;
          state.cartPricingReady = false;
          state.cartPricingFailed = true;
        })
        .then(function () {
          if (requestId !== state.cartRequestId) return state.cartPricingReady;
          root.removeAttribute('aria-busy');
          if (renderTotals) renderTotals();
          return state.cartPricingReady;
        });
    }

    function syncUntouchedSlotsToSlot1() {
      var baseProduct = slotProduct(state.slots[0]);
      var baseTitle = variantTitle(baseProduct, state.slots[0].variantId);

      for (var i = 1; i < state.slots.length; i++) {
        if (state.slots[i].sizeTouched) continue;
        var p = slotProduct(state.slots[i]);
        var nextVariantId = preferredVariant(p, baseTitle);
        if (nextVariantId) state.slots[i].variantId = nextVariantId;
        if (slotEls[i]) renderSlot(i);
      }
    }

    function resetSlot1ToCurrent() {
      var previousProduct = slotProduct(state.slots[0]);
      var previousTitle = variantTitle(previousProduct, state.slots[0].variantId);
      var nativeVariant = pdpSelectedVariant();
      var nativeTitle = variantTitle(current, nativeVariant);
      var nextVariantId = preferredVariant(current, previousTitle || nativeTitle) || nativeVariant || firstAvailableVariant(current);

      state.slots[0] = {
        productId: current.id,
        variantId: nextVariantId,
        sizeTouched: false
      };
    }

    /* La taille PDP change → resynchronise le slot 1 s'il porte toujours
       le produit de la page (capture : certains selects ne bubblent pas). */
    document.addEventListener('change', function (e) {
      if (!e.target || e.target.name !== 'id') return;
      var form = e.target.closest('form');
      if (form && !formMatchesBuilder(form)) return;

      var id = parseInt(e.target.value, 10);
      if (state.slots[0].productId !== current.id) return;
      if (!current.variants.some(function (v) { return v.id === id && v.available; })) return;

      state.slots[0].variantId = id;
      syncUntouchedSlotsToSlot1();
      renderSlot(0);
      renderTotals();
    }, true);

    /* ---------- rendu ---------- */

    renderSlot = function (index) {
      var slotEl = slotEls[index];
      var slot = state.slots[index];
      var p = slotProduct(slot);
      if (!slotEl || !p) return;

      var variant = slotVariant(slot);
      if (variant && variant.id !== slot.variantId) slot.variantId = variant.id;

      var img = slotEl.querySelector('[data-slot-image]');
      img.src = p.image;
      img.alt = p.model + ' ' + p.color;
      slotEl.querySelector('[data-slot-model]').textContent = p.model;
      slotEl.querySelector('[data-slot-color]').textContent = p.color;
      slotEl.querySelector('[data-slot-price]').innerHTML = beforeAfter(slotCompare(slot), slotPrice(slot));

      var sizesEl = slotEl.querySelector('[data-slot-sizes]');
      Array.prototype.slice.call(sizesEl.querySelectorAll('.rm-slot__size-pill')).forEach(function (el) {
        el.remove();
      });
      p.variants.forEach(function (v) {
        var pill = document.createElement('label');
        pill.className = 'rm-slot__size-pill';
        if (!v.available) pill.classList.add('is-soldout');

        var radio = document.createElement('input');
        radio.type = 'radio';
        radio.className = 'sr-only';
        radio.name = 'rm-size-' + builderNamespace + '-' + index + '-' + p.id;
        radio.value = v.id;
        radio.disabled = !v.available;
        radio.checked = v.id === slot.variantId;
        radio.addEventListener('change', function () {
          state.slots[index].variantId = v.id;
          if (index > 0) state.slots[index].sizeTouched = true;
          if (index === 0) syncUntouchedSlotsToSlot1();
          renderTotals();
        });
        pill.appendChild(radio);

        var txt = document.createElement('span');
        txt.textContent = v.title;
        if (!v.available) txt.title = labels.sold_out || 'Sold out';
        pill.appendChild(txt);

        sizesEl.appendChild(pill);
      });

      renderPicker(index);
    };

    /* Sélecteur de taille intégré DANS la carte "1 short" (pas de slot séparé) :
       pilote la taille du short courant = state.slots[0]. */
    function renderTier1Sizes() {
      if (!tier1SizesEl) return;
      Array.prototype.slice.call(tier1SizesEl.querySelectorAll('.rm-slot__size-pill')).forEach(function (el) {
        el.remove();
      });

      current.variants.forEach(function (v) {
        var pill = document.createElement('label');
        pill.className = 'rm-slot__size-pill';
        if (!v.available) pill.classList.add('is-soldout');

        var radio = document.createElement('input');
        radio.type = 'radio';
        radio.className = 'sr-only';
        radio.name = 'rm-tier1-size-' + builderNamespace + '-' + current.id;
        radio.value = v.id;
        radio.disabled = !v.available;
        radio.checked = state.slots[0].productId === current.id && v.id === state.slots[0].variantId;
        radio.addEventListener('change', function () {
          state.slots[0] = { productId: current.id, variantId: v.id, sizeTouched: false };
          syncUntouchedSlotsToSlot1();
          renderSlot(0);
          renderTotals();
        });
        pill.appendChild(radio);

        var txt = document.createElement('span');
        txt.textContent = v.title;
        if (!v.available) txt.title = labels.sold_out || 'Sold out';
        pill.appendChild(txt);

        tier1SizesEl.appendChild(pill);
      });
    }

    function renderPicker(index) {
      var slotEl = slotEls[index];
      var optionsEl = slotEl.querySelector('[data-slot-options]');
      optionsEl.innerHTML = '';

      if (models.length > 1 && labels.models_note) {
        var note = document.createElement('p');
        note.className = 'rm-slot__models-note';
        note.textContent = labels.models_note;
        optionsEl.appendChild(note);
      }

      models.forEach(function (model) {
        var group = document.createElement('div');
        group.className = 'rm-slot__group';
        var header = document.createElement('p');
        header.className = 'rm-slot__group-title';
        header.textContent = model;
        group.appendChild(header);

        products.forEach(function (p) {
          if (p.model !== model) return;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'rm-slot__option';
          btn.setAttribute(
            'aria-label',
            p.model + ' — ' + (p.color || p.model) + ' — ' + money(p.price)
          );
          if (p.id === state.slots[index].productId) btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', p.id === state.slots[index].productId ? 'true' : 'false');

          var thumb = document.createElement('img');
          thumb.src = p.image;
          thumb.alt = '';
          thumb.width = 44;
          thumb.height = 44;
          thumb.loading = 'lazy';
          btn.appendChild(thumb);

          var label = document.createElement('span');
          label.className = 'rm-slot__option-label';
          label.textContent = p.color || p.model;
          btn.appendChild(label);

          var price = document.createElement('span');
          price.className = 'rm-slot__option-price';
          price.textContent = money(p.price);
          btn.appendChild(price);

          btn.addEventListener('click', function () {
            var currentSlotProduct = slotProduct(state.slots[index]);
            var currentSlotTitle = variantTitle(currentSlotProduct, state.slots[index].variantId);
            var slot1Product = slotProduct(state.slots[0]);
            var slot1Title = variantTitle(slot1Product, state.slots[0].variantId);

            state.slots[index] = {
              productId: p.id,
              variantId: preferredVariant(p, currentSlotTitle || slot1Title),
              sizeTouched: index > 0 ? false : state.slots[index].sizeTouched
            };
            if (index === 0) syncUntouchedSlotsToSlot1();
            slotEl.querySelector('[data-slot-picker]').open = false;
            renderSlot(index);
            renderTotals();
          });
          group.appendChild(btn);
        });
        optionsEl.appendChild(group);
      });
    }

    /* Déplace les slots + le total juste SOUS le palier sélectionné
       (au lieu de toujours après la carte "3 shorts"). */
    function positionSlots() {
      var checked = root.querySelector('input[name^="rm-builder-tier"]:checked');
      var slotsEl = root.querySelector('[data-builder-slots]');
      var footerEl = root.querySelector('[data-builder-footer]');
      if (!checked || !slotsEl || !footerEl) return;
      var card = checked.closest('.rm-bundle__tier');
      if (!card) return;
      card.insertAdjacentElement('afterend', slotsEl);
      slotsEl.insertAdjacentElement('afterend', footerEl);
    }

    renderTotals = function () {
      var single = state.tier === 1;
      if (single) resetSlot1ToCurrent();
      var t = totals();
      var footer = root.querySelector('[data-builder-footer]');
      var slotsEl = root.querySelector('[data-builder-slots]');
      var before = root.querySelector('[data-builder-total-before]');
      var after = root.querySelector('[data-builder-total-after]');
      var label = root.querySelector('[data-builder-total-label]');
      var savingRow = root.querySelector('[data-builder-saving-row]');
      var savingLabel = root.querySelector('[data-builder-saving-label]');
      var cartContext = root.querySelector('[data-builder-cart-context]');

      root.classList.toggle('rm-builder--single', single);
      setQuantityVisible(single);
      if (tier1SizesEl) tier1SizesEl.hidden = !single;
      renderTier1Sizes();
      slotsEl.hidden = single;
      footer.hidden = single;
      if (!single) positionSlots();

      /* Le panier existant peut faire passer le pack directement au palier 25% ou 35%. */
      var totalShortCount = state.cartPricingReady ? state.cartShortCount + state.tier : state.tier;
      var tierPercent = tierDiscountPercent(totalShortCount);
      var slotFlag =
        ' <span class="rm-slot__price-flag">' +
        (labels.slot_discount || '-{percent}%').replace('{percent}', tierPercent) +
        '</span>';
      for (var i = 0; i < slotEls.length; i++) {
        slotEls[i].hidden = i >= state.tier;
        if (i >= state.tier) continue;
        var priceEl = slotEls[i].querySelector('[data-slot-price]');
        var compare = slotCompare(state.slots[i]);
        var target = offerPrice(compare, totalShortCount);
        priceEl.innerHTML = '<s>' + money(compare) + '</s> <strong>' + money(target) + '</strong>' + slotFlag;
      }

      if (t.regularBefore > t.after) {
        before.hidden = false;
        before.textContent = money(t.regularBefore);
      } else {
        before.hidden = true;
      }
      label.textContent = labels.total || 'Total';
      if (savingRow && savingLabel) {
        savingRow.hidden = t.totalSaving <= 0;
        savingLabel.textContent = (labels.saving || 'You save {amount}')
          .replace('{amount}', money(t.totalSaving));
      }
      after.textContent = money(t.after);
      if (cartContext) {
        if (state.cartPricingReady && state.cartShortCount > 0) {
          cartContext.hidden = false;
          cartContext.textContent = labels.cart_context || 'Price adjusted for shorts already in your cart.';
        } else if (state.cartPricingFailed) {
          cartContext.hidden = false;
          cartContext.textContent = labels.cart_unavailable || 'Final price confirmed in cart.';
        } else {
          cartContext.hidden = true;
          cartContext.textContent = '';
        }
      }

      /* Prix par palier sur les radios (calculés sur les slots actuels). */
      var tierEls = root.querySelectorAll('[data-tier-price]');
      for (var j = 0; j < tierEls.length; j++) {
        var n = parseInt(tierEls[j].getAttribute('data-tier-price'), 10);
        var subset = tierSlots(n);
        var tierTotals = totalsForSlots(subset);
        var afterN = tierTotals.after;
        tierEls[j].innerHTML = beforeAfter(tierTotals.regularBefore, afterN);
        var unitEl = root.querySelector('[data-tier-unit="' + n + '"]');
        if (unitEl) {
          var showUnit = n >= 2;
          unitEl.hidden = !showUnit;
          unitEl.textContent = showUnit
            ? (labels.per_unit || '{price} /short').replace('{price}', money(Math.round(afterN / n)))
            : '';
        }
      }
    };

    /* ---------- events ---------- */

    root.querySelector('[data-builder-tiers]').addEventListener('change', function (e) {
      if (e.target.type !== 'radio' || e.target.name.indexOf('rm-builder-tier-') !== 0) return;
      state.tier = parseInt(e.target.value, 10) || 1;
      if (state.tier === 1) resetSlot1ToCurrent();
      syncUntouchedSlotsToSlot1();
      renderSlot(0);
      renderTotals();
    });

    ['shapes:cart:afteradditem', 'shapes:cart:cartqtychange', 'shapes:cart:update'].forEach(function (eventName) {
      window.addEventListener(eventName, function () {
        if (document.documentElement.contains(root)) refreshCartPricing();
      });
    });

    /* Un seul bouton d'achat : le submit du formulaire produit NATIF ajoute le
       pack sélectionné. Capture sur document = on passe avant le handler Alpine. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!formMatchesBuilder(form)) return;

      e.preventDefault();
      e.stopPropagation();

      if (state.tier === 1) resetSlot1ToCurrent();
      var formId = form.getAttribute('id');
      var errorEl = root.querySelector('[data-builder-error]');
      errorEl.hidden = true;

      var items = visibleSlots().map(function (s) {
        return { id: s.variantId, quantity: 1 };
      });
      if (items.some(function (it) { return !it.id; })) return;

      /* Palier 1 : respecter la quantité du stepper natif du thème. */
      if (state.tier === 1) {
        var qtyInput = quantityInput(form);
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        items[0].quantity = qty > 0 ? qty : 1;
      }

      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      refreshCartPricing()
        .then(function () {
          return fetch(cartRoute('cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
            body: JSON.stringify({
              items: items,
              sections: CART_SECTIONS,
              sections_url: window.location.pathname
            })
          });
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function (response) {
          var eventResponse = response;
          if (!eventResponse.key && response.items && response.items.length) {
            eventResponse = Object.assign({}, response, {
              key: response.items[0].key,
              variant_id: response.items[0].variant_id
            });
          }
          document.body.dispatchEvent(
            new CustomEvent('shapes:cart:afteradditem', {
              bubbles: true,
              detail: { response: eventResponse, sourceId: formId }
            })
          );

          if (window.posthog && typeof window.posthog.capture === 'function') {
            window.posthog.capture('bundle_builder_add', {
              tier: state.tier,
              item_count: items.length,
              variant_ids: items.map(function (item) { return item.id; }),
              total_cents: totals().after
            });
          }
        })
        .catch(function (err) {
          errorEl.textContent = (err && err.description) || labels.error || 'Unable to add the pack.';
          errorEl.hidden = false;
          errorEl.scrollIntoView({ block: 'nearest' });
        })
        .then(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    }, true);

    /* ---------- init ---------- */
    renderSlot(0);
    renderSlot(1);
    renderSlot(2);
    refreshCartPricing();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-rm-builder]');
    for (var i = 0; i < roots.length; i++) initBuilder(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
